import React from 'react';
import PropTypes from 'prop-types';
import { Container } from '@fiverr-private/layout_components';
import { aiPillRevealClass } from '../styles.ve.css';
import { getRevealDelay } from '../getRevealDelay';

const ChipsContainer = ({ ids, Chip }) => (
    <Container as="ul" display="flex" flexWrap="wrap" gap="3">
        {ids.map((id, index) => (
            <Container
                as="li"
                display="inlineFlex"
                key={id}
                className={aiPillRevealClass}
                style={{ animationDelay: getRevealDelay(index) }}
            >
                <Chip id={id} />
            </Container>
        ))}
    </Container>
);

ChipsContainer.propTypes = {
    ids: PropTypes.arrayOf(PropTypes.string),
    Chip: PropTypes.elementType.isRequired,
};

ChipsContainer.defaultProps = {
    ids: [],
};

export { ChipsContainer };
export default ChipsContainer;
